/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl, intlShape } from 'react-intl';

import Notification from '@xingternal/malt-notification';
import Flag from '@xingternal/malt-flag';
/* eslint-disable no-unused-vars */
/* list of icons appearing in the navigation */
import {
  IconNavigationStartpage,
  IconNavigationContacts,
  IconNavigationMessenger,
  IconComplexPremiumDiamond,
  IconNavigationProexecutives,
  IconNavigationProjobs,
  IconProfileEducation,
  IconNavigationJobs,
  IconNavigationEvents,
  IconNavigationNews,
  IconNavigationCommunities,
  IconNavigationCompanies,
  IconNavigationBusinessServices,
  IconNavigationOtherServices,
} from '@xingternal/malt-icon';
/* eslint-enable */

import { TrackedLink, withTracking, eitherOr } from '../../../../xing-tracking';
import trackings from '../../../../trackings';

import styles from './NavItem.css';

const NavItem = ({
  meta = { title: '', href: '' },
  isActive,
  hasUser,
  notificationCount = 0,
  intl: { formatMessage },
}) => {
  const renderFlag = (flagType, flagText) =>
    flagType || flagText ? (
      <Flag className={styles.flag} type={flagType} />
    ) : null;

  const IconElement = meta.iconOdl || null;
  const cls = meta.secondary ? styles.titleSecondary : styles.title;
  const text = meta.subTitle ? (
    <div className={styles.text}>
      <p className={cls}>
        {formatMessage({ id: meta.title })}
        {renderFlag(meta.flagType, meta.flagText)}
      </p>
      <p className={styles.subTitle}>{formatMessage({ id: meta.subTitle })}</p>
    </div>
  ) : (
    <p className={`${cls} ${styles.text} ${styles.standAlone}`}>
      {hasUser ? (
        formatMessage({ id: meta.title })
      ) : (
        <span className={styles.itemTextPlaceholder} />
      )}

      {renderFlag(meta.flagType || '', meta.flagText || '')}
    </p>
  );

  const trackingConditions = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    sc_o_PropActionOrigin: eitherOr(notificationCount),
  };

  return (
    <li
      className={classNames(styles.navItem, {
        [styles[meta.key]]: Boolean(meta.key),
      })}
    >
      {hasUser ? (
        <Fragment>
          <TrackedLink
            href={meta.href}
            trackingKey={meta.key}
            className={classNames(styles.link, { [styles.active]: isActive })}
            conditions={trackingConditions}
          >
            {IconElement && (
              <IconElement
                className={styles.icon}
                aria-label={formatMessage({ id: meta.title })}
              />
            )}
            {text}
            <Notification
              className={styles.notification}
              count={notificationCount}
              max={99}
            />
          </TrackedLink>

          <div className={styles.tooltip}>
            {formatMessage({ id: meta.title })}
            {meta.subTitle && ` – ${formatMessage({ id: meta.subTitle })}`}
          </div>
        </Fragment>
      ) : (
        <div className={classNames(styles.link)}>
          <span className={classNames(styles.icon, styles.iconPlaceholder)} />
          {text}
        </div>
      )}
    </li>
  );
};

NavItem.displaName = 'NavItem';

NavItem.propTypes = {
  meta: PropTypes.shape({
    iconOdl: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    secondary: PropTypes.bool,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    flagType: PropTypes.string,
    key: PropTypes.string.isRequired,
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    flagText: PropTypes.string,
  }),
  intl: intlShape,
  isActive: PropTypes.bool,
  hasUser: PropTypes.bool.isRequired,
  notificationCount: PropTypes.number,
};

export default injectIntl(withTracking(trackings)(NavItem));
